
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-66120l",
"minContentWidth": "--awsui-min-content-width-66120l",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-66120l",
"contentGapLeft": "--awsui-content-gap-left-66120l",
"contentGapRight": "--awsui-content-gap-right-66120l",
"contentHeight": "--awsui-content-height-66120l",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-66120l",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-66120l",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-66120l",
"defaultMaxContentWidth": "--awsui-default-max-content-width-66120l",
"defaultMinContentWidth": "--awsui-default-min-content-width-66120l",
"drawerSize": "--awsui-drawer-size-66120l",
"drawerMinSize": "--awsui-drawer-min-size-66120l",
"bottomDrawerSize": "--awsui-bottom-drawer-size-66120l",
"footerHeight": "--awsui-footer-height-66120l",
"headerGap": "--awsui-header-gap-66120l",
"headerHeight": "--awsui-header-height-66120l",
"layoutWidth": "--awsui-layout-width-66120l",
"mainGap": "--awsui-main-gap-66120l",
"mainOffsetLeft": "--awsui-main-offset-left-66120l",
"mainTemplateRows": "--awsui-main-template-rows-66120l",
"mobileBarHeight": "--awsui-mobile-bar-height-66120l",
"notificationsHeight": "--awsui-notifications-height-66120l",
"offsetTop": "--awsui-offset-top-66120l",
"overlapHeight": "--awsui-overlap-height-66120l",
"navigationWidth": "--awsui-navigation-width-66120l",
"navigationCollapsedWidth": "--awsui-navigation-collapsed-width-66120l",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-66120l",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-66120l",
"splitPanelHeight": "--awsui-split-panel-height-66120l",
"splitPanelMinWidth": "--awsui-split-panel-min-width-66120l",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-66120l",
"toolsMaxWidth": "--awsui-tools-max-width-66120l",
"toolsWidth": "--awsui-tools-width-66120l",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-66120l",
"contentScrollMargin": "--awsui-content-scroll-margin-66120l",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-66120l",
"flashbarStackIndex": "--awsui-flashbar-stack-index-66120l",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-66120l",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-66120l",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-66120l",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-66120l",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-66120l",
"dropdownContentBorderColor": "--awsui-dropdown-content-border-color-66120l",
"dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-66120l",
"dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-66120l",
"modalCustomWidth": "--awsui-modal-custom-width-66120l",
"modalCustomHeight": "--awsui-modal-custom-height-66120l",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-66120l",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-66120l",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-66120l",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-66120l",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-66120l",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-66120l",
"sliderLabelCount": "--awsui-slider-label-count-66120l",
"sliderTickCount": "--awsui-slider-tick-count-66120l",
"sliderReferenceColumn": "--awsui-slider-reference-column-66120l",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-66120l",
"sliderMaxStart": "--awsui-slider-max-start-66120l",
"sliderMinEnd": "--awsui-slider-min-end-66120l",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-66120l",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-66120l",
"togglesLeftWidth": "--awsui-toggles-left-width-66120l",
"togglesRightWidth": "--awsui-toggles-right-width-66120l",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-66120l",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-66120l",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-66120l",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-66120l",
"styleBackgroundActive": "--awsui-style-background-active-66120l",
"styleBackgroundDefault": "--awsui-style-background-default-66120l",
"styleBackgroundDisabled": "--awsui-style-background-disabled-66120l",
"styleBackgroundHover": "--awsui-style-background-hover-66120l",
"styleBorderColorActive": "--awsui-style-border-color-active-66120l",
"styleBorderColorDefault": "--awsui-style-border-color-default-66120l",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-66120l",
"styleBorderColorHover": "--awsui-style-border-color-hover-66120l",
"styleColorActive": "--awsui-style-color-active-66120l",
"styleColorDefault": "--awsui-style-color-default-66120l",
"styleColorDisabled": "--awsui-style-color-disabled-66120l",
"styleColorHover": "--awsui-style-color-hover-66120l",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-66120l",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-66120l",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-66120l",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-66120l",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-66120l",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-66120l",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-66120l",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-66120l",
"styleBackgroundReadonly": "--awsui-style-background-readonly-66120l",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-66120l",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-66120l",
"styleColorReadonly": "--awsui-style-color-readonly-66120l",
"styleBackgroundFocus": "--awsui-style-background-focus-66120l",
"styleBorderColorFocus": "--awsui-style-border-color-focus-66120l",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-66120l",
"styleColorFocus": "--awsui-style-color-focus-66120l",
"stylePlaceholderColor": "--awsui-style-placeholder-color-66120l",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-66120l",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-66120l",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-66120l",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-66120l",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-66120l",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-66120l",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-66120l",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-66120l",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-66120l",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-66120l",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-66120l",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-66120l",
"alertIconColor": "--awsui-alert-icon-color-66120l",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-66120l",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-66120l",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-66120l",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-66120l",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-66120l",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-66120l",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-66120l",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-66120l",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-66120l",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-66120l",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-66120l",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-66120l",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-66120l",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-66120l",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-66120l",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-66120l",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-66120l",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-66120l",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-66120l",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-66120l",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-66120l",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-66120l",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-66120l",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-66120l",
"promptInputMenuStyleBackgroundColor": "--awsui-prompt-input-menu-style-background-color-66120l",
"promptInputMenuStyleBorderColor": "--awsui-prompt-input-menu-style-border-color-66120l",
"promptInputMenuStyleBorderRadius": "--awsui-prompt-input-menu-style-border-radius-66120l",
"promptInputMenuStyleBorderWidth": "--awsui-prompt-input-menu-style-border-width-66120l",
"optionBackgroundDefault": "--awsui-option-background-default-66120l",
"optionBackgroundHighlighted": "--awsui-option-background-highlighted-66120l",
"optionBackgroundSelected": "--awsui-option-background-selected-66120l",
"optionColorDefault": "--awsui-option-color-default-66120l",
"optionColorHighlighted": "--awsui-option-color-highlighted-66120l",
"optionColorDisabled": "--awsui-option-color-disabled-66120l",
"optionGroupLabelColor": "--awsui-option-group-label-color-66120l",
"optionFilterMatchBackground": "--awsui-option-filter-match-background-66120l",
"optionFilterMatchColor": "--awsui-option-filter-match-color-66120l",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-66120l",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-66120l",
"progressBarHeight": "--awsui-progress-bar-height-66120l",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-66120l",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-66120l",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-66120l",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-66120l",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-66120l",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-66120l",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-66120l",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-66120l",
"tokenStyleBackgroundDefault": "--awsui-token-style-background-default-66120l",
"tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-66120l",
"tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-66120l",
"tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-66120l",
"tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-66120l",
"tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-66120l",
"tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-66120l",
"tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-66120l",
"tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-66120l",
"tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-66120l",
"styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-66120l",
"styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-66120l",
"styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-66120l",
"styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-66120l",
"styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-66120l",
"inlineLabelBackgroundColor": "--awsui-inline-label-background-color-66120l",
      };
      export default customCSSPropertiesMap;
    